<div class="ml-10 py-[2px]">
  <button
    type="button"
    mat-button
    class="action-button"
    [attr.aria-label]="
      hasSelection() ? 'Add Step and Move Treatments' : 'Add Step'
    "
    (click)="clicked.emit()"
  >
    <mat-icon>add</mat-icon>
    @if (hasSelection()) {
      <span class="text-xs">Add Step &amp; Move Treatments</span>
    } @else {
      <span class="text-xs">Add Step</span>
    }
  </button>
</div>
